import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/checkcircle.svg'


const _hoisted_1 = { class: "layout-eoi" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "back-map" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["HeaderCustomer"], { estate: $setup.estate }, null, 8, ["estate"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"logo-box\" data-v-2768609a><img src=\"" + _imports_0 + "\" data-v-2768609a></div><div class=\"headline\" data-v-2768609a>Saved to Drafts</div><div class=\"description\" data-v-2768609a>Your Contract information form has been saved in your drafts folder. You can return to your saved form at any time by visiting the My Lots section of your LotTrackr dashboard.</div><div class=\"back-dashboard\" data-v-2768609a><a class=\"button\" href=\"/customer/lots\" data-v-2768609a>My Dashboard</a></div>", 4)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "back",
            href: `/estate/${$setup.estateId}`
          }, "Back to Map", 8, _hoisted_5)
        ])
      ])
    ])
  ]))
}